export default "__VITE_ASSET__566a4415__"